import { am5, am5xy } from '@local/finsera-core/src/libs';

import { FONT_SIZE } from '../../../../theme/layout-size';

export const createAxes = ({
  root,
  chart,
  xAxisLabel,
  yAxisLabel,
  xAxisFormatter,
  yAxisFormatter,
  xIsDate,
}: {
  root: am5.Root;
  chart: am5xy.XYChart;
  xAxisLabel: string;
  yAxisLabel: string;
  xAxisFormatter: string | undefined;
  yAxisFormatter: string | undefined;
  xIsDate: boolean;
}) => {
  // Create X axis
  const xAxisTooltip = am5.Tooltip.new(root, {});
  xAxisTooltip.label.setAll({ fontSize: 11 });

  let xAxisRenderer;
  if (xIsDate) {
    xAxisRenderer = am5xy.DateAxis.new(root, {
      baseInterval: { timeUnit: 'day', count: 1 },
      renderer: am5xy.AxisRendererX.new(root, { minorGridEnabled: true }),
      tooltip: xAxisTooltip,
      autoZoom: false,
    });
  } else {
    xAxisRenderer = am5xy.ValueAxis.new(root, {
      renderer: am5xy.AxisRendererX.new(root, { minGridDistance: 50 }),
      tooltip: xAxisTooltip,
      autoZoom: false,
      numberFormat: xAxisFormatter,
    });
  }
  const xAxis = chart.xAxes.push(xAxisRenderer);

  // Add X axis title
  xAxis.children.push(
    am5.Label.new(root, {
      text: xAxisLabel,
      x: am5.percent(44),
      centerX: am5.p50,
      fontSize: FONT_SIZE.xxs,
      marginTop: 10,
    })
  );

  // Create Y axis
  const yAxisTooltip = am5.Tooltip.new(root, {});
  yAxisTooltip.label.setAll({ fontSize: 11 });
  const yAxis = chart.yAxes.push(
    am5xy.ValueAxis.new(root, {
      renderer: am5xy.AxisRendererY.new(root, {}),
      tooltip: yAxisTooltip,
      autoZoom: false,
      numberFormat: yAxisFormatter,
    })
  );

  // Add Y axis title
  yAxis.children.unshift(
    am5.Label.new(root, {
      rotation: -90,
      text: yAxisLabel,
      y: am5.p50,
      centerX: am5.p50,
      fontSize: FONT_SIZE.xxs,
    })
  );

  // Add cursor
  chart.set(
    'cursor',
    am5xy.XYCursor.new(root, {
      xAxis: xAxis,
      yAxis: yAxis,
    })
  );

  return { xAxis, yAxis };
};
